var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"vertical-center mb-0"},[_vm._v(_vm._s(_vm.currentDate)+" "+_vm._s(_vm.currentTime))])}
var staticRenderFns = []

export { render, staticRenderFns }